import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from "@angular/core";
import { provideHttpClient } from "@angular/common/http";
import { provideClientHydration } from "@angular/platform-browser";
import { InMemoryScrollingFeature, NavigationError, provideRouter, withDebugTracing, withHashLocation, withInMemoryScrolling, withNavigationErrorHandler } from "@angular/router";
import { routes } from "@app/routes";

// import { TranslocoService } from "@ngneat/transloco";
// import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { Store } from "@services/store/store.service";
import { RequestCache } from "@services/api/cache-interceptor/request-cache";
import { RequestCacheWithMap } from "@services/api/cache-interceptor/request-cache-map";

import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { NavigationService } from "./services/navigation/navigation.service";
import * as Sentry from "@sentry/angular";
import { Router } from "@angular/router";

let debug = environment.debug;

const CHUNK_LOAD_ERROR = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;
const CHUNK_RELOAD_KEY = "chunk-reload-attempted";

function handleChunkLoadError(error: NavigationError): void {
	if (typeof window === "undefined") return;
	if (!CHUNK_LOAD_ERROR.test(String(error.error?.message ?? error.error ?? ""))) return;
	if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;

	sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
	window.location.reload();
}

let routeProvider = provideRouter(
	routes,
	withInMemoryScrolling({
		scrollPositionRestoration: 'top',
		// anchorScrolling: 'enabled',
	}),
	withNavigationErrorHandler(handleChunkLoadError),
	// withDebugTracing(),
);
const sentryProvider = [
	{
		provide: ErrorHandler,
		useValue: Sentry.createErrorHandler(),
	},
	{
		provide: Sentry.TraceService,
		deps: [Router],
	},
	{
		provide: APP_INITIALIZER,
		useFactory: () => () => { },
		deps: [Sentry.TraceService],
		multi: true,
	},
];

export const appConfig: ApplicationConfig = {
	providers: [
		Store,
		MessageService,
		NavigationService,
		ToastModule,
		routeProvider,
		provideAnimations(),
		provideClientHydration(),
		// provideToastr(),
		{ provide: RequestCache, useClass: RequestCacheWithMap },
		...sentryProvider,
	],
}

